// extracted by mini-css-extract-plugin
export default {"item":"UserChatItem_item__KX63z","noti":"UserChatItem_noti__hIiBX","active":"UserChatItem_active__7VX1-"};